import React, { FC, memo } from 'react'

import { useNavigate } from 'react-router-dom'

import { auth } from '@sportworld/js-sdk/src/actions/auth'

import { Button } from '@/components/Button/Button'
import { paths } from '@/constants/paths'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { ErrorContainer, ErrorWrapper } from './styles'

const ErrorRaw: FC = () => {
  const navigate = useNavigate()
  const { t } = useCommonTranslation()
  /**
   * @description page opens on app critical error (e.g. network error, token refresh error, etc.)
   */

  const reset = () => {
    localStorage.clear()

    auth().then(() => {
      navigate(`${paths.SETTINGS}/${paths.SETTINGS_ACCOUNT}`)
    })
  }

  return (
    <ErrorContainer>
      <ErrorWrapper>
        <p>Something went wrong</p>
        <p>
          <Button text={t('reload')} onClick={reset} />
        </p>
      </ErrorWrapper>
    </ErrorContainer>
  )
}

export const Error = memo(ErrorRaw)
